/**
 * Medical On Demand Confirmation Screen
 *
 * Success screen displayed after question submission.
 */

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { headerItem } from '@/components/HeaderActions';
import { SuccessScreen } from '@/components/SuccessScreen';
import { Header } from '@/components/header';
import { VStack } from '@/components/ui/vstack';

type InquirySubmitSuccessScreenProps = {
  onDismiss: () => void;
};

export function InquirySubmitSuccessScreen({ onDismiss }: InquirySubmitSuccessScreenProps) {
  const { bottom } = useSafeAreaInsets();

  return (
    <VStack className="flex-1 bg-primary-500" style={{ paddingBottom: bottom }}>
      <Header fill="brand" leftItems={[headerItem.close(onDismiss)]} />

      <SuccessScreen
        heading="Question submitted"
        description="Your question has been submitted to J&J Medical. You'll receive a response in your Primum inbox once it's been reviewed."
        riveAnimation="SHARING_INFORMATION_LIGHT_GREEN"
        buttonText="Return Home"
        onButtonPress={onDismiss}
      />
    </VStack>
  );
}
